export const COMMON_SAGA = 'COMMON_SAGA';
export const COMMON_START = 'COMMON_START';
export const COMMON_FAIL = 'COMMON_FAIL';
export const COMMON_SUCCESS = 'COMMON_SUCCESS';